import { Button, Table, Input, Space, Select, message, Typography, Alert } from "antd"
import PageContentWrapper from "../../components/PageContentWrapper"
import { useEffect, useState } from "react"
import { getConfiguration, updateConfiguration } from "../../appRedux/actions/Configuration"
import CircularProgress from "../../components/CircularProgress"
import { PlusOutlined, SaveOutlined } from "@ant-design/icons"

export default function UTM() {
  const [dataSource, setDataSource] = useState(null)
  const configurationName = "utm"

  useEffect(() => {
    getConfiguration(configurationName).then(data => {
      try {
        const parsed = JSON.parse(data.value)
        setDataSource(Array.isArray(parsed) ? parsed : [])
      } catch (e) {
        setDataSource([])
      }
    })
  }, [])

  const handleAdd = () => {
    const newData = {
      key: Date.now().toString(),
      parameter: '',
      value: '',
      description: '',
    }
    setDataSource([...dataSource, newData])
  }

  const handleCellChange = (key, dataIndex, value) => {
    const newData = [...dataSource]
    const index = newData.findIndex((item) => key === item.key)
    if (index > -1) {
      const item = newData[index]
      newData.splice(index, 1, { ...item, [dataIndex]: value })
      setDataSource(newData)
    }
  }

  const onSave = () => {
    // Melakukan trim pada semua inputan
    const trimmedData = dataSource.map(item => ({
      ...item,
      parameter: item.parameter?.trim(),
      value: item.value?.trim(),
      description: item.description?.trim(),
    }))

    const hasEmptyFields = trimmedData.some(
      (item) => !item.parameter || !item.value || !item.description
    )

    if (hasEmptyFields) {
      return message.error("Mohon lengkapi semua kolom sebelum menyimpan!")
    }

    // Pengecekan duplikasi kombinasi parameter dan value
    const seenEntries = new Set()
    for (const item of trimmedData) {
      const entryKey = `${item.parameter}:${item.value}`
      if (seenEntries.has(entryKey)) {
        return message.error(`Kombinasi parameter "${item.parameter}" dengan nilai "${item.value}" sudah ada!`)
      }
      seenEntries.add(entryKey)
    }

    setDataSource(trimmedData) // Update state agar UI menampilkan nilai yang sudah di-trim

    updateConfiguration({
      name: configurationName,
      value: JSON.stringify(trimmedData)
    }).then(() => message.success("Konfigurasi UTM berhasil disimpan"))
  }

  const columns = [
    {
      title: 'Parameter',
      dataIndex: 'parameter',
      render: (text, record) => (
        <Select
          value={text}
          onChange={(value) => handleCellChange(record.key, 'parameter', value)}
          placeholder="Pilih Parameter"
          status={!text ? "error" : ""}
          style={{ width: '100%' }}
        >
          <Select.Option value="utm_source">utm_source</Select.Option>
          <Select.Option value="utm_medium">utm_medium</Select.Option>
          <Select.Option value="utm_campaign">utm_campaign</Select.Option>
          <Select.Option value="utm_content">utm_content</Select.Option>
          <Select.Option value="utm_term">utm_term</Select.Option>
        </Select>
      ),
    },
    {
      title: 'Value',
      dataIndex: 'value',
      render: (text, record) => (
        <Input 
          value={text} 
          onChange={(e) => handleCellChange(record.key, 'value', e.target.value)} 
          placeholder="e.g. google" 
          status={!text ? "error" : ""}
        />
      ),
    },
    {
      title: 'Keterangan',
      dataIndex: 'description',
      render: (text, record) => (
        <Input 
          value={text} 
          onChange={(e) => handleCellChange(record.key, 'description', e.target.value)} 
          placeholder="e.g. Sumber kampanye" 
          status={!text ? "error" : ""}
        />
      ),
    },
  ]

  if (dataSource === null) return <CircularProgress />

  return (
    <PageContentWrapper title="UTM (Urchin Tracking Module)" backLink={"/configurations"}>
      <Space direction="vertical" style={{ width: '100%' }}>
        <Alert
          message="Panduan Parameter UTM"
          type="info"
          showIcon={false}
          description={
            <Typography.Paragraph style={{ marginBottom: 0 }}>
              <ul style={{ paddingLeft: '1.5em', marginBottom: 0 }}>
                <li><b>utm_source</b>: Mengidentifikasi sumber lalu lintas (contoh: google, facebook, newsletter).</li>
                <li><b>utm_medium</b>: Mengidentifikasi media iklan atau pemasaran (contoh: cpc, email, social).</li>
                <li><b>utm_campaign</b>: Nama kampanye, promo, atau strategi produk tertentu.</li>
                <li><b>utm_content</b>: Digunakan untuk membedakan konten serupa atau link dalam satu iklan (A/B testing).</li>
                <li><b>utm_term</b>: Digunakan untuk mengidentifikasi kata kunci pencarian berbayar.</li>
              </ul>
            </Typography.Paragraph>
          }
        />

        <Table
          bordered
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          rowKey="key"
        />

        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <Button onClick={handleAdd} type="dashed" icon={<PlusOutlined />}>
            Tambah Parameter UTM
          </Button>
          <Button type="primary" icon={<SaveOutlined />} size="large" onClick={onSave}>
            Simpan Perubahan
          </Button>
        </div>

      </Space>
    </PageContentWrapper>
  )
}